import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './index.css';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-145">
    <BrowserRouter data-id="element-146">
      <App data-id="element-147" />
    </BrowserRouter>
  </React.StrictMode>);